import Api from "@/services/Index";

const setBaseUrl = () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
};

const getAll = (config) => {
    setBaseUrl();
    return Api.get("/accounts-receivable/contacts", config);
};

const get = (id) => {
    setBaseUrl();
    return Api.get(`/accounts-receivable/contacts/${id}`);
};


const store = (data) => {
    setBaseUrl();
    return Api.post("/accounts-receivable/contacts", data);
};


const update = (id, data) => {
    setBaseUrl();
    return Api.put(`/accounts-receivable/contacts/${id}`, data);
};


const remove = (id) => {
    setBaseUrl();
    return Api.delete(`/accounts-receivable/contacts/${id}`);
};


export default {
    getAll,
    get,
    store,
    update,
    remove
};
